import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=161425e1&scoped=true&"
import script from "./NotificationItem.vue?vue&type=script&lang=js&"
export * from "./NotificationItem.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/header.scss?vue&type=style&index=0&id=161425e1&lang=scss&scoped=true&"
import style1 from "./NotificationItem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161425e1",
  null
  
)

export default component.exports